import React, { useEffect, useState } from "react";
import "../../index.css"
import { baseUrl, loadData } from "../../config/data";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import ViewConfig from "../../config/viewConfig";
import { Link, useParams } from "react-router-dom";
import { setLanguage } from "../../redux/actions/language";

const Blogs = ({ }) => {
    const mobileView = ViewConfig();
    const { lang } = useSelector((state) => state.globalReducer);

    const [blogData, setBlogData] = useState([]);
    const [blogDataCount, setBlogDataCount] = useState(0);
    const [blogPage, setblogPage] = useState(0);

    const dispatch = useDispatch();
    const { language } = useParams();

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])

    const loadBlogData = async (page) => {
        loadData({
            url: `Blogs`,
            params: [{ title: 'limit', value: 5 }, { title: 'page', value: page === 0 ? 0 : (blogPage + 1) }, { title: 'filter', value: 'status:Published' }],
        }).then(async res => {
            if (res?.data) {
                const resData = res.data;
                if (blogData.length > 0) {
                    setBlogData(prev => [...prev, ...resData]);
                } else {
                    setBlogData(resData)
                }
                setBlogDataCount(res.total);
                setblogPage(res?.page)
            }
        })
    };

    useEffect(() => {
        loadBlogData(0);
    }, [])

    return (<>
        <div className="pt-8 mb-24 max-w-[1680px] mx-auto">
            <p className='text-[#48494B] text-[32px] md:text-[72px] font-normal leading-tight text-center'>{Lang(lang, 'life_at')} <b className='text-[#EA2427] font-semibold'>SOPRA</b></p>
            <div className='flex flex-row flex-wrap items-center justify-between mt-10 mx-auto w-[85%] md:w-[70%]'>
                {blogData && blogData?.map((obj, idx) =>
                    idx === 0 || idx % 5 === 0 ?
                        <Link key={obj.blogID} to={`/${lang}/blogs/detail?id=${obj.blogID}`} className='relative rounded-[20px] md:rounded-[35px] p-5 text-sm font-normal w-full bg-white' style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}>
                            <div className='h-[200px] md:h-[387px] bg-slate-600 rounded-[20px]'>
                                <img src={baseUrl + '/' + (obj?.blogThumbnail || obj?.blogImage)} className="w-full h-full object-cover rounded-[20px]" />
                            </div>
                            <div className='flex flex-row items-end justify-between'>
                                <div className='text-[#48494B] p-2'>
                                    <div className="flex flex-row pt-3">
                                        {obj.blogTags && (obj.blogTags?.split(',').map(tag => tag.trim())).map((val, idx) => (
                                            <div key={idx} className='py-1 px-2 mr-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                <p className='text-[11px] md:text-xs'>{val}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <h3 className='pt-2 text-sm md:text-lg font-medium truncate-2-lines'>{lang === 'en' ? obj?.blogTitle_en : obj?.blogTitle_id}</h3>
                                    <div className='h-[43px] w-[95%] overflow-hidden'>
                                        <div className="pl-3 pt-2 text-xs truncate-2-lines" dangerouslySetInnerHTML={{ __html: lang === 'en' ? obj?.blogContent_en : obj?.blogContent_id }} />
                                    </div>
                                </div>
                                <img className='w-[35px] md:w-[45px]' src="/asset/arrowNews.png" />
                            </div>
                        </Link>
                        :
                        <Link to={`/${lang}/blogs/detail?id=${obj.blogID}`} className={`flex flex-row rounded-[20px] md:rounded-[30px] mt-4 text-left text-sm md:text-lg font-normal w-full md:w-[49%] h-[200px] md:h-[263px] bg-white`} style={{ boxShadow: '1px 0px 6px 0px rgb(0 0 0 / 15%)' }}>
                            <div className='rounded-s-[20px] md:rounded-s-[30px] bg-slate-600 w-[60%] md:w-[70%] h-full' style={{ backgroundImage: `url('${baseUrl + '/' + (obj?.blogThumbnail || obj?.blogImage)}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                            <div className='p-2 pr-4 flex flex-col items-end gap-2 justify-between w-full'>
                                <div className='flex flex-col'>
                                    <div className="px-3 flex flex-row pt-1 pb-2 md:pt-5 gap-2">
                                        {<div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                            <p className='text-[11px] md:text-xs'>{obj.blogTags?.split(',').map(tag => tag.trim())[0]}</p>
                                        </div>}
                                        {((`${obj.blogTags}`.includes(',') ? `${obj.blogTags}`.split(',').map(tag => tag.trim()) : [obj.blogTags]).length > 1 &&
                                            <div className='py-1 px-2 rounded-xl md:rounded-full bg-[#E4F0FF]'>
                                                <p className='text-[11px] md:text-xs'>+{(obj.blogTags?.split(',').map(tag => tag.trim())).length - 1}</p>
                                            </div>)}
                                    </div>
                                    <p className='pl-3 pt-0 md:pt-2 text-[#48494B] font-medium truncate-2-lines'>{lang === 'en' ? obj?.blogTitle_en : obj?.blogTitle_id}</p>
                                    <div className='w-[95%]'>
                                        <div className='pl-3 pt-2 text-xs truncate-2-lines' dangerouslySetInnerHTML={{ __html: lang === 'en' ? obj?.blogContent_en : obj?.blogContent_id }} />
                                    </div>
                                </div>
                                <img className='w-[35px] md:w-[45px]' src="/asset/arrowNews.png" />
                            </div>
                        </Link>
                )}
            </div>
            <div className="flex justify-center mt-10">
                {blogData && (blogDataCount > blogData.length && <a href="" className="bg-[#EA2427] text-white rounded-full mt-4 py-1 px-4 cursor-pointer font-semibold" onClick={(e) => {
                    e.preventDefault();
                    loadBlogData()
                }}>{Lang(lang, 'read_more')}</a>)}
            </div>
        </div>
    </>)
}

export default Blogs